import { render, staticRenderFns } from "./OrderMobileCard.vue?vue&type=template&id=62a321d8&scoped=true&"
import script from "./OrderMobileCard.vue?vue&type=script&lang=js&"
export * from "./OrderMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderMobileCard.vue?vue&type=style&index=0&id=62a321d8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a321d8",
  null
  
)

export default component.exports